const getState = (state: AppState) => state.blog;

export const blogSelector = {
  getState,
};
